export const UPDATE_USER      = 'UPDATE_USER';
export const LOGOUT           = 'LOGOUT';
export const LOADER           = 'LOADER';
export const LOAD_DATA        = 'LOAD_DATA';
export const LOAD_CHILDREN    = 'LOAD_CHILDREN';
export const UPDATE_FAVORITE  = 'UPDATE_FAVORITE';
export const LOAD_FOOTER_INFO = 'LOAD_FOOTER_INFO';